module.exports = __webpack_public_path__ + "static/media/icon_vue.80a2b33f.png";